import { render, staticRenderFns } from "./UpcomingList.vue?vue&type=template&id=7962ee6c&scoped=true&"
import script from "./UpcomingList.vue?vue&type=script&lang=js&"
export * from "./UpcomingList.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingList.vue?vue&type=style&index=0&id=7962ee6c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962ee6c",
  null
  
)

export default component.exports